export var getLabGrotesqueBaselineCompensation = function getLabGrotesqueBaselineCompensation(fontSize, compensation, isChrome, isFirefox) {
  if (fontSize < 16 && !isChrome) {
    return compensation;
  } else if (fontSize === 16 && isChrome || fontSize === 18 && (isFirefox || isChrome)) {
    return -compensation;
  }

  return 0;
};